class ProductShippingPromise extends HTMLElement {
  connectedCallback() {
    this.message = this.querySelector('[data-shipping-message]');
    this.section = this.closest('.shopify-section');
    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
    (this.section || document).addEventListener('variant:update', this.handleVariantUpdate);
    this.render({
      price: Number(this.dataset.initialPrice || 0),
      available: this.dataset.initialAvailable === 'true'
    });
  }

  disconnectedCallback() {
    (this.section || document).removeEventListener('variant:update', this.handleVariantUpdate);
  }

  handleVariantUpdate(event) {
    const variant = event.detail && event.detail.resource;
    if (!variant) return;
    this.render(variant);
  }

  cleanRoundingStep(amount) {
    if (amount < 1000) return 5;
    if (amount < 10000) return 50;
    if (amount < 100000) return 500;
    if (amount < 1000000) return 5000;
    return 50000;
  }

  localThreshold() {
    const baseThreshold = Number(this.dataset.baseThreshold || 22000);
    const shopifyRate = Number(globalThis.Shopify && globalThis.Shopify.currency && globalThis.Shopify.currency.rate);
    const rate = Number.isFinite(shopifyRate) && shopifyRate > 0 ? shopifyRate : 1;
    const convertedAmount = (baseThreshold / 100) * rate;
    const roundingStep = this.cleanRoundingStep(convertedAmount);
    const cleanAmount = Math.ceil((convertedAmount - Number.EPSILON) / roundingStep) * roundingStep;
    return Math.round(cleanAmount * 100);
  }

  formattedThreshold(threshold) {
    const currency = this.dataset.currency || 'USD';
    const locale = document.documentElement.lang || 'en';
    try {
      const amount = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(threshold / 100);
      return amount.includes(currency) ? amount : amount + ' ' + currency;
    } catch (error) {
      return Math.round(threshold / 100) + ' ' + currency;
    }
  }

  render(variant) {
    const price = Number(variant.price || 0);
    const available = typeof variant.available === 'boolean'
      ? variant.available
      : this.dataset.initialAvailable === 'true';

    if (!this.message || !Number.isFinite(price) || price <= 0 || !available) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
    const threshold = this.localThreshold();
    this.message.textContent = price >= threshold
      ? this.dataset.freeText
      : this.dataset.overText + this.formattedThreshold(threshold);
  }
}

if (!customElements.get('product-shipping-promise')) {
  customElements.define('product-shipping-promise', ProductShippingPromise);
}
